module.exports = __webpack_public_path__ + "img/pickupGroups.7024fac5.png";